import axios from "axios";
import config from "./config";
import jwtDecode from "jwt-decode";
import { LOADING_USER, STOP_LOADING_USER } from "../redux/types";

// Redux stuff
import { softLogoutUser, getUserData } from "../redux/actions/userActions";

// This function checks if a user's idToken from firebase is valid. If it isnt, it tries to refresh it using a refresh token
// If it cannot get a new idToken it will log the user out and take them to the login page
export const validateFBIdToken = () => async (dispatch) => {
  const token = localStorage.FBIdToken;
  const refreshToken = localStorage.FBRefreshToken;

  if (token && refreshToken) {
    const decodedToken = jwtDecode(token);

    // if token expired, try to refresh
    if (decodedToken.exp * 1000 < Date.now()) {
      console.log("Token is expired");

      // Create clean version of axios without common Auth header
      var cleanAxios = axios.create();
      cleanAxios.defaults.headers.common = {};

      // try to refresh idToken
      try {
        const newTokenResponse = await cleanAxios.post(
          `https://securetoken.googleapis.com/v1/token?key=${config.prod.apiKey}`,
          {
            grant_type: "refresh_token",
            refresh_token: refreshToken,
          }
        );

        let newToken = `Bearer ${newTokenResponse.data.id_token}`;

        // Refresh success
        localStorage.FBIdToken = newToken;
        axios.defaults.headers.common["Authorization"] = newToken;

        console.log("Refreshed FB token sucessfully. Logging in.");
        dispatch(getUserData());

        return true;
      } catch (err) {
        // Refresh failure
        console.log("Unable to refresh id token, loggin out.", err);

        // If failure to refresh, logout
        dispatch(softLogoutUser());

        window.open("/login", "_blank");
        return false;
      }
    } else {
      // Token is valid
      return true;
    }
  } else {
    console.log("No token found");
    // No token found, redirect to login.
    dispatch(softLogoutUser());
    window.open("/login", "_blank");
    return false;
  }
};

export const refreshFBIdToken = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    console.log("refreshing FBIdToken");
    dispatch({ type: LOADING_USER });

    const token = localStorage.FBIdToken;
    const refreshToken = localStorage.FBRefreshToken;

    if (token && refreshToken) {
      // Try to refresh
      // Create clean version of axios without common Auth header
      var cleanAxios = axios.create();
      cleanAxios.defaults.headers.common = {};

      // try to refresh idToken
      cleanAxios
        .post(
          `https://securetoken.googleapis.com/v1/token?key=${config.prod.apiKey}`,
          {
            grant_type: "refresh_token",
            refresh_token: refreshToken,
          }
        )
        .then((res) => {
          let newToken = `Bearer ${res.data.id_token}`;
          // Refresh success
          localStorage.FBIdToken = newToken;
          axios.defaults.headers.common["Authorization"] = newToken;

          console.log("Refreshed FB token sucessfully. Logging in.");
          dispatch(getUserData());
          resolve("Refreshed FB token sucessfully. Logging in.");
        })
        .catch((err) => {
          // Refresh failure
          console.log("Unable to refresh id token, loggin out.", err);

          // If failure to refresh, logout
          dispatch(softLogoutUser());

          reject("Unable to refresh id token, loggin out.", err);
        });
    } else {
      console.log("No token found");
      // No token found, redirect to login.
      dispatch(softLogoutUser());

      reject("No token found");
    }
  });
};
